import { GetStaticProps } from "next";
import dynamic from "next/dynamic";
import Head from "next/head";
import * as React from "react";
import { useEffect } from "react";
import { nineSolsTheme } from "../../src/Digital/Product/Project/ProjectPage/ProjectTheme";
import {
  ComicProvider,
  ComicSectionProvider,
} from "../../src/Event/ComicVote/ComicContext";
import {
  ComicEvent,
  ComicSectionData,
  version,
} from "../../src/Event/ComicVote/ComicType";
// import NineSolsEventPage from "../../src/Event/Menu/NineSolsEventPage";
import { storyblokClient } from "../../src/Storyblok/storyblok";
import { useChangeAppBarColor } from "../../src/Theme/ThemeContext";
import { useSetTheme } from "../../src/Theme/useSetTheme";

const NineSolsEventPage = dynamic(
  () => import("../../src/Event/Menu/NineSolsEventPage"),
  { ssr: false }
);
// const GamePage = dynamic(
//   () => import("../../src/Digital/Product/Game/GamePage")
// );

// export default function NineSolsEventPage({ story }: { story: StoryData }) {
export default function NineSolsEventRoute({
  comicEvent,
  sections,
}: {
  comicEvent: ComicEvent;
  sections: ComicSectionData[];
}) {
  useChangeAppBarColor("#101828");
  useSetTheme(nineSolsTheme);
  useEffect(() => {
    console.log("Comics", sections);
  }, [sections]);
  return (
    <div className="comic-event" style={{ backgroundColor: "#101828" }}>
      <style jsx global>
        {`
          ::-webkit-scrollbar-thumb {
            background: #eac57d;
            border: 2px solid transparent;
            border-radius: 5px;
            background-clip: content-box;
          }
        `}
      </style>
      <Head key="comic_event">
        <title>{comicEvent.title}</title>
        {/* <meta
          name="keywords"
          content="赤燭遊戲,Red Candle  Games,RedCandleGames,還願,Devotion,台灣家庭,八零年代,恐怖遊戲,解謎遊戲"
        ></meta> */}
        <meta
          property="og:title"
          content={"《" + comicEvent.meta.og_title + "》"}
        ></meta>
        <meta
          property="og:url"
          content={"https://shop.redcandlegames.com/event/shanhai9000"}
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content={comicEvent.meta.og_image + "/m/"}
        ></meta>
        <meta name="description" content={comicEvent.meta.description}></meta>
        <meta
          property="og:description"
          content={comicEvent.meta.description}
        ></meta>
        <meta
          property="og:site_name"
          content="RedCandle E-Shop 赤燭網路商店"
        ></meta>
        <meta property="fb:app_id" content="1108842882812885"></meta>
      </Head>
      <ComicProvider sections={sections} comicEvent={comicEvent}>
        <ComicSectionProvider comicSection={sections[sections.length - 1]}>
          <NineSolsEventPage sections={sections}></NineSolsEventPage>
        </ComicSectionProvider>
      </ComicProvider>
    </div>
  );
}
export const getStaticProps: GetStaticProps = async ({ params, locale }) => {
  let cv = await storyblokClient
    .get("cdn/spaces/me", {})
    .then((response) => {
      console.log("Space", response);
      return response.data.space.version;
    })
    .catch((error) => {
      console.log(error);
    });
  console.log("CV", cv);

  const results = await storyblokClient.getStories({
    starts_with: "event/comics",
    version: version,
    cv: cv,
    language: locale.toLocaleLowerCase(),
  });

  const comicEvent = await storyblokClient.getStory("event/ninesolscomic", {
    version: version,
    cv: cv,
    language: locale.toLocaleLowerCase(),
  });

  console.log(comicEvent.data.story.content);

  return {
    props: {
      sections: results.data.stories,
      comicEvent: comicEvent.data.story.content,
      // story: story.data.story,
    },
  };
};

//static path??
